import * as React from 'react';
import styled from 'styled-components';

const StyledThumbnail = styled.img`
    height: 150px;
    width: 150px;
    object-fit: contain;
`;

type PlannerItemThumbnailProps = {
    thumbnailUrl: string;
};

export function PlannerItemThumbnail({ thumbnailUrl }: PlannerItemThumbnailProps) {
    return <StyledThumbnail src={thumbnailUrl} />;
}
PlannerItemThumbnail.displayName = 'PlannerItemThumbnail';
